// EXTERNAL DEPENDENCIES
import React from 'react'
import { Routes, Route } from 'react-router-dom'

// COMPONENTS
import CenteredLoadingSpinner from './common/components/loading/centered-loading-spinner'
import RouteTracker from './common/components/tracking/route-tracking'
import ErrorBoundary from './common/components/ui/errors/error-boundary'

// HELPERS
import { useEventListening } from './hooks'
import { trackClicksFromElementData } from './utils/fpti'
import { logError } from './utils/client-error'
import { getRoutes } from './routes'

export default function App() {
  useEventListening('click', trackClicksFromElementData)

  // log all uncaught js errors
  window.onerror = (
    msg: string,
    _source: string,
    _line: number,
    _col: number,
    error: Error,
    // eslint-disable-next-line max-params
  ) => {
    logError({
      message: msg,
      stack: error?.stack,
    })
  }

  return (
    <div>
      <ErrorBoundary>
        <React.Suspense fallback={<CenteredLoadingSpinner height={'70vh'} />}>
          <Routes>
            <Route element={<RouteTracker />}>
              {getRoutes().map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
            </Route>
          </Routes>
        </React.Suspense>
      </ErrorBoundary>
    </div>
  )
}
